import React from 'react';
import CategoryBadge from './CategoryBadge';

const HeroNews = ({ news }) => {
  if (!news) return null;

  const handleClick = () => {
    window.open(news.sourceUrl, '_blank', 'noopener,noreferrer');
  };

  return (
    <section className="mb-8">
      <article
        className="relative group cursor-pointer overflow-hidden rounded-2xl shadow-xl"
        onClick={handleClick}
      >
        {/* Background Image */}
        <div className="aspect-[16/7] lg:aspect-[21/9]">
          <img
            src={news.image}
            alt={news.title}
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
            onError={(e) => {
              e.target.src = 'https://via.placeholder.com/1200x500?text=Ana+Haber';
            }}
          />
        </div>

        {/* Gradient Overlay */}
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent"></div>

        {/* Content */}
        <div className="absolute bottom-0 left-0 right-0 p-6 lg:p-10">
          <div className="max-w-3xl">
            <div className="mb-4">
              <CategoryBadge category={news.category} />
            </div>
            
            <h2 className="text-2xl lg:text-4xl font-bold text-white mb-4 group-hover:text-blue-300 transition-colors">
              {news.title}
            </h2>

            <div className="flex items-center space-x-4 text-gray-300 text-sm lg:text-base">
              <span className="font-medium text-white">{news.source}</span>
              <span>•</span>
              <span>{news.relativeTime}</span>
              <span>•</span>
              <span className="flex items-center">
                <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                {news.readTime} dk okuma
              </span>
            </div>

            <button
              className="mt-6 inline-flex items-center px-6 py-3 bg-white/10 hover:bg-white/20 backdrop-blur-sm text-white rounded-lg transition-colors border border-white/20"
            >
              <span>Haberi Oku</span>
              <svg className="w-5 h-5 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
              </svg>
            </button>
          </div>
        </div>
      </article>
    </section>
  );
};

export default HeroNews;
